import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import NachVeitsbronn from "./components/NachVeitsbronn";
import Index from "./pages/Index";
import HaarePage from "./pages/HaarePage";
import FacialsPage from "./pages/FacialsPage";
import WimpernPage from "./pages/WimpernPage";
import NaegelPage from "./pages/NaegelPage";
import TeamPage from "./pages/TeamPage";
import AnfragePage from "./pages/AnfragePage";
import HaarentfernungPage from "./pages/HaarentfernungPage";
import LeistungenPage from "./pages/LeistungenPage";
import ImpressumPage from "./pages/ImpressumPage";
import DatenschutzPage from "./pages/DatenschutzPage";
import CookieBanner from "./components/CookieBanner";
import NotFound from "./pages/NotFound";
import BlogPage from "./pages/BlogPage";
import GelnagelKostenPage from "./pages/blog/GelnagelKostenPage";
import WimpernPflegePage from "./pages/blog/WimpernPflegePage";
import IplLaserVergleichPage from "./pages/blog/IplLaserVergleichPage";
import DauerhafteHaarentfernungGuidePage from "./pages/blog/DauerhafteHaarentfernungGuidePage";

const queryClient = new QueryClient();

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Keine Standortwahl mehr — die Startseite ist Nürnberg. */}
            <Route path="/" element={<Navigate to="/nuernberg" replace />} />

            {/* Nürnberg Studio */}
            <Route path="/nuernberg" element={<Index />} />
            <Route path="/nuernberg/haare" element={<HaarePage />} />
            <Route path="/nuernberg/facials" element={<FacialsPage />} />
            <Route path="/nuernberg/naegel" element={<NaegelPage />} />
            <Route path="/nuernberg/team" element={<TeamPage />} />
            <Route path="/nuernberg/haarentfernung" element={<HaarentfernungPage />} />
            <Route path="/nuernberg/leistungen" element={<LeistungenPage />} />
            <Route path="/nuernberg/anfrage" element={<AnfragePage />} />
            <Route path="/nuernberg/impressum" element={<ImpressumPage />} />
            <Route path="/nuernberg/datenschutz" element={<DatenschutzPage />} />
            <Route path="/nuernberg/blog" element={<BlogPage />} />
            <Route path="/nuernberg/blog/gelnaegel-kosten-nuernberg" element={<GelnagelKostenPage />} />
            <Route path="/nuernberg/blog/wimpernverlaengerung-pflege-tipps" element={<WimpernPflegePage />} />
            <Route path="/nuernberg/blog/dauerhafte-haarentfernung-ipl-laser-unterschied" element={<IplLaserVergleichPage />} />
            <Route path="/nuernberg/blog/dauerhafte-haarentfernung-nuernberg-ratgeber" element={<DauerhafteHaarentfernungGuidePage />} />

            {/* Veitsbronn läuft seit 02.10.2026 unter 22studiosveitsbronn.de.
                Alte Links werden auf die passende Seite dort weitergeleitet. */}
            <Route path="/veitsbronn" element={<NachVeitsbronn />} />
            <Route path="/veitsbronn/*" element={<NachVeitsbronn />} />
            <Route path="/veitrsbronn/*" element={<NachVeitsbronn />} />
            <Route path="/veitrbronn/*" element={<NachVeitsbronn />} />

            {/* Redirects: old routes → new /nuernberg/ routes */}
            <Route path="/haare" element={<Navigate to="/nuernberg/haare" replace />} />
            <Route path="/facials" element={<Navigate to="/nuernberg/facials" replace />} />
            <Route path="/naegel" element={<Navigate to="/nuernberg/naegel" replace />} />
            <Route path="/team" element={<Navigate to="/nuernberg/team" replace />} />
            <Route path="/haarentfernung" element={<Navigate to="/nuernberg/haarentfernung" replace />} />
            <Route path="/leistungen" element={<Navigate to="/nuernberg/leistungen" replace />} />
            <Route path="/anfrage" element={<Navigate to="/nuernberg/anfrage" replace />} />
            <Route path="/impressum" element={<Navigate to="/nuernberg/impressum" replace />} />
            <Route path="/datenschutz" element={<Navigate to="/nuernberg/datenschutz" replace />} />
            <Route path="/blog" element={<Navigate to="/nuernberg/blog" replace />} />
            <Route path="/blog/*" element={<Navigate to="/nuernberg/blog" replace />} />

            {/* Legacy redirects */}
            <Route path="/leistungen/facials" element={<Navigate to="/nuernberg/facials" replace />} />
            <Route path="/leistungen/haare" element={<Navigate to="/nuernberg/haare" replace />} />
            <Route path="/leistungen/nagel" element={<Navigate to="/nuernberg/naegel" replace />} />
            <Route path="/kontakt" element={<Navigate to="/nuernberg/anfrage" replace />} />

            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
